import React, { memo } from 'react';

import Notification from './Notification';
import { SystemNotificationsProps } from './types';

const SystemNotificationList = ({
  notifications,
}: SystemNotificationsProps): React.JSX.Element => (
  <>
    {notifications.map(({ id, ...restNotificationProps }) => (
      <Notification key={id} {...restNotificationProps} />
    ))}
  </>
);

export default memo(SystemNotificationList);
